<template>
  <quiz-layout class="admin">
    <template #sidebar>
      <div class="sidebar__menu">
        <router-link class="menu__item" :to="`/admin`">
          <div class="item__title">Lessons</div>
        </router-link>
        <router-link class="menu__item" :to="`/admin/users`">
          <div class="item__title">Users</div>
        </router-link>
        <router-link class="menu__item" :to="`/admin/rewards`">
          <div class="item__title">Rewards</div>
        </router-link>
        <router-link class="menu__item" :to="`/admin/rewards/claims`">
          <div class="item__title">Claims</div>
        </router-link>
      </div>
    </template>
    <template>
      <div class="content__title">Rewards</div>
      <div class="content__section">
        <div
          class="reward__item"
          v-for="(item, index) in rewards"
          :key="index"
          @click="editReward(item)"
        >
          <div class="reward__photo">
            <img :src="item.photo" />
          </div>
          <div class="reward__details">
            <div class="reward__title">
              <span>{{ item.title }}</span>
              <span>{{ item.quantity }}</span>
            </div>
            <div class="reward__description">
              {{ item.description }}
            </div>
            <div class="reward__price">
              <span>Price</span>
              <span class="reward__price--bold">{{ item.price }}</span>
            </div>
          </div>
        </div>
      </div>
      <b-modal id="editReward" centered hide-header hide-footer @hidden="close">
        <template v-if="selected">
          <h3 class="mb-3 text-center">Edit Reward</h3>
          <b-form-group
            label="Title"
            label-for="rewardName"
            :state="state.title"
            invalid-feedback="Title is required"
          >
            <b-form-input
              id="rewardName"
              v-model="selected.title"
              type="text"
              :state="state.title"
              required
            />
          </b-form-group>
          <b-form-group
            label="Price"
            label-for="rewardPrice"
            invalid-feedback="Price should be a postive integer. Eg: 5"
            :state="state.price"
          >
            <b-form-input
              type="number"
              id="rewardPrice"
              v-model.number="selected.price"
              min="1"
              required
              :state="state.price"
            />
          </b-form-group>
          <b-form-group
            label="Quantity"
            label-for="rewardQuantity"
            invalid-feedback="Quantity should be a positive float. Eg: 0.5"
            :state="state.quantity"
          >
            <b-form-input
              type="number"
              id="rewardQuantity"
              min="0"
              v-model.number="selected.quantity"
              required
              :state="state.quantity"
            />
          </b-form-group>
          <b-form-group>
            <label for="rewardName"> Description </label>
            <b-form-textarea
              id="description"
              v-model="selected.description"
              placeholder="Enter something..."
              rows="3"
              max-rows="3"
            />
          </b-form-group>
          <div class="text-center">
            <b-btn
              variant="primary"
              class="mr-3 pl-3 pr-3"
              role="submit"
              @click="edit"
            >
              Edit
            </b-btn>
            <b-btn variant="secondary" class="mr-3 pl-3 pr-3" @click="close()">
              Cancel
            </b-btn>
          </div>
        </template>
      </b-modal>
    </template>
  </quiz-layout>
</template>
<script>
import QuizLayout from "../layout/QuizLayout.vue";
import { RewardService } from "../data/services/rewards.service";
export default {
  components: { QuizLayout },
  data() {
    return {
      rewards: [],
      selected: null,
      state: {
        title: null,
        price: null,
        quantity: null,
      },
    };
  },
  mounted() {
    this.getRewards();
  },
  methods: {
    getService() {
      return new RewardService();
    },
    async getRewards() {
      const rewardService = this.getService();
      this.rewards = await rewardService.getRewards();
    },
    close() {
      this.selected = null;
      this.$bvModal.hide("editReward");
    },
    edit() {
      if (this.selected === null) {
        return;
      }
      if (this.selected.title === "") {
        this.state.title = false;
      }
      if (this.selected.price === "" || this.selected.price < 1) {
        this.state.price = false;
      }
      if (this.selected.quantity === "" || this.selected.quantity < 0) {
        this.state.quantity = false;
      }

      const validity = this.isValid();
      if (validity === false) {
        return;
      }

      const payload = this.selected;
      const id = payload._id;
      delete payload._id;

      this.getService()
        .updateItem(id, payload)
        .then(() => {
          this.$bvModal.hide("editReward");
          this.selected = null;
          this.getRewards();
          this.$notify({
            title: "Success",
            text: "Reward has been updated",
          });
        })
        .catch((error) => {
          console.log({ error });
          this.$notify({
            type: "warn",
            title: "Error",
            text: "Something went wrong try again later.",
          });
        });
    },
    isValid() {
      const items = Object.keys(this.state);
      const stateHolder = this.state;
      return items.reduce((result, current) => {
        return (
          result &&
          (stateHolder[current] === null ? true : stateHolder[current])
        );
      }, true);
    },
    editReward(reward) {
      this.selected = JSON.parse(JSON.stringify(reward));
      this.$bvModal.show("editReward");
      this.state.title = null;
      this.state.quantity = null;
      this.state.price = null;
    },
  },
};
</script>
<style lang="scss" scoped>
.content__section {
  --items-per-row: 4;
  --item-margin: 16px;

  display: flex;
  flex-wrap: wrap;

  @media screen and (max-width: 475px) {
    --items-per-row: 2;
  }
  @media screen and (max-width: 1200px) {
    --items-per-row: 3;
  }
}
.reward {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  &__item {
    width: calc(100% / var(--items-per-row) - var(--item-margin) - 0.01px);
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 5px;
    overflow: hidden;
    cursor: pointer;
    margin-left: calc(var(--item-margin)/2);
    margin-right: calc(var(--item-margin)/2);
  }
  &__photo {
    width: 100%;
    padding: 18px;
    display: flex;
    align-content: center;
    justify-content: center;
    background: #ffffff;
    img {
      width: 100%;
      object-fit: contain;
    }
  }
  &__details {
    width: 100%;
    padding: 15px;
    background: #f4f4f5;
  }
  &__title {
    font-weight: 700;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__description {
    font-size: 14px;
    color: #8d9296;
  }
  &__price {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &--bold {
      font-weight: 700;
    }
  }
}
</style>